import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=3d6c3fb2&scoped=true&"
import script from "./Education.vue?vue&type=script&lang=js&"
export * from "./Education.vue?vue&type=script&lang=js&"
import style0 from "./Education.vue?vue&type=style&index=0&id=3d6c3fb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c3fb2",
  null
  
)

export default component.exports